@if (broadcast) {
<div
  [innerHTML]="broadcast.text"
  [ngStyle]="{ 'background-color': broadcast.background, color: broadcast.foreground }"
  class="px-2 py-1"
></div>
}
